var _defs, _rect, _path, _g, _path2, _path3, _path4, _g2, _g3, _path5, _g4, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _g5, _path15, _g6, _g7, _g8, _path16, _path17, _path18, _circle, _g9, _g10, _g11, _g12, _g13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContactUs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 560,
    height: 330,
    viewBox: "0 0 560 330",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -0.692,
    y1: 0.5,
    x2: 0.308,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#343a44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.301,
    stopColor: "#232c3d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.639,
    stopColor: "#172339"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#142138"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.15,
    y1: 0.5,
    x2: 1.15,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Contact_us"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 560,
    height: 330
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Contact_us",
    "data-name": "Contact us",
    clipPath: "url(#clip-Contact_us)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 560,
    height: 330,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS",
    transform: "translate(-93.251 -54)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_37",
    "data-name": "Group 37"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_36",
    "data-name": "Group 36"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M138.358,257.536C107.59,276.885,91.473,320.487,116.381,378.6H606.436c8.316-21.052,13.3-48.709,14.858-65.17,3.41-35.915-8.8-73.22-30.321-92.915-54.46-49.842-99.739,19.39-128.368-9.878-16.525-16.894-14.959-64.312-27.89-86.323-28.542-48.587-82.283-72.54-135.265-63.943-35.258,5.722-67.059,24.383-86.458,55.95-26.571,43.237-7.23,74.213-18.958,104.1C180.958,253.728,158.914,244.61,138.358,257.536Z",
    fill: "#e7f0fd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8",
    "data-name": "Group 8"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M181.944,181.311c-.069.279,4.477-2.544,4.477-2.544l1.92-2.978s1.879-1.213,3.224-1.867,3.821-4.679,3.821-4.679l-.979-1.229a16.815,16.815,0,0,1-1.876,2,2.4,2.4,0,0,1-1.41.046,25.287,25.287,0,0,1,1.084-3.037,28.3,28.3,0,0,1,3.047-4.674l-.862-.9a24.733,24.733,0,0,0-1.876,1.964c-.5.657-1.451,2.037-1.451,2.037a27.2,27.2,0,0,1,1.6-3.336c.614-.907,1.28-2.135,1.28-2.135l-1-.692a22.5,22.5,0,0,0-1.766,2.516c-.6,1.077-1.711,2.864-1.711,2.864a35.453,35.453,0,0,1,1.263-3.532,12.6,12.6,0,0,0,.574-1.195l-1.182-.4a9.493,9.493,0,0,0-1.4,2.5,13.231,13.231,0,0,1-.9,2.063,14.194,14.194,0,0,1,.74-2.994,2.6,2.6,0,0,0,.4-.958l-.958-.181s-1.841,3.389-2.806,5.49-1.722,4.94-2.268,6.477a59.393,59.393,0,0,0-1.254,6.77Z",
    fill: "#f5c5b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M210.294,201.437,187,197.425a77.655,77.655,0,0,1-.253-11.938c.411-6.973,1.265-8.914,1.265-8.914l-6.251-.865s-1.234,5.49-2.119,9.436c-1.963,8.75-3.757,16.946-2.259,18.773,2.176,2.651,21.561,8.047,28.194,13.022C209.568,219.932,209.335,210.347,210.294,201.437Z",
    fill: "#196aa8"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M243.324,267.673l-1.178,8.057,2.435,5.522,1.779-2.4.41-4.5,2.629.4,1.291-1.619-.112-3.374-.433-9.181Z",
    fill: "#fec4ad"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M241.69,206.258c-1.795-.663-7.652-.23-7.652-.23s-.553,6.254,1.826,11.084,8.277,22.426,9.024,24.078-1.564,26.483-1.564,26.483l8.557-1.754s4.124-19.15,4.092-24.018-4.586-23.088-7.823-28.9S246.046,207.867,241.69,206.258Z",
    fill: "#196aa8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M227.592,188.346s-1.883,8.257-.41,10.177c.863,1.126,4.522,5.136,4.522,5.136s-12.122,6.4-15.685,6.4-2.315-7.148-2.315-7.148,3.886-3.072,4.465-4.624a34.875,34.875,0,0,0,.9-6.045Z",
    fill: "#fec4ad"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6",
    "data-name": "Group 6"
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M229.01,188.653s-.138-3.007,2.381-2.93c1.608.049,1.733,1.523.48,3.425-.528.8-.581,2.611-1.236,3.193-.8.708-1.462-.384-1.7-.882A5.991,5.991,0,0,1,229.01,188.653Z",
    fill: "#f5c5b3"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    "data-name": "Group 4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M215.438,188.653s.139-3.007-2.381-2.93c-1.608.049-1.733,1.523-.48,3.425.528.8.581,2.611,1.236,3.193.8.708,1.462-.384,1.7-.882A5.991,5.991,0,0,0,215.438,188.653Z",
    fill: "#f5c5b3"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M231.564,181.293a28.578,28.578,0,0,1-.509,3.059c-.06.349-.125.748-.191,1.211-.521,3.609-1.181,8.517-1.466,9.249-.471,1.214-3.049,3.181-4.273,3.9a7.351,7.351,0,0,1-5.528-.147c-1.225-.72-3.994-2.539-4.465-3.753-.289-.746-.973-5.795-1.5-9.465-.06-.418-.118-.779-.174-1.1a27.634,27.634,0,0,1-.5-2.956c-.187-3.049,3.245-7.484,9.3-7.484C229.428,173.809,231.753,178.244,231.564,181.293Z",
    fill: "#f5c5b3"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M216,177.45a14.484,14.484,0,0,1,11.092.406l2.137-1.361a17.528,17.528,0,0,0-7.592-1.6C217.158,174.931,216,177.45,216,177.45Z",
    fill: "#e8d4e5",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_5",
    "data-name": "Group 5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M231.055,184.352c-.059.349-.125.748-.191,1.211-.521,3.609-1.181,8.517-1.466,9.249-.47,1.214-3.049,3.181-4.273,3.9a7.351,7.351,0,0,1-5.528-.147c-1.225-.72-3.995-2.539-4.465-3.753-.289-.746-.973-5.795-1.5-9.465-.06-.418-.117-.779-.173-1.1l.494-.738s.892,5.233,2.258,6.858,1.625,1.7,1.625,1.7l2.794-.69.223-.056a6.563,6.563,0,0,1,3.259.026c.059.014.117.03.177.048l.2.06,2.116.612s.493-.076,1.859-1.7,2.024-6.858,2.024-6.858Z",
    fill: "#7b2b1a"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M232,179.341c-.02.1-.512,3.665-.713,4.229-.31.864-.547,1.488-.547,1.488l-.367-.8a11.863,11.863,0,0,1-1.083-4.709l-.065-3.057,1.017-.9C232.249,175.9,232.464,177.056,232,179.341Z",
    fill: "#7b2b1a"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M216.121,176.653l0,.014-.488,3.145a11.882,11.882,0,0,1-1.462,4.139l-.042.072-.555.957s-.163-.556-.39-1.346c-.168-.582-.582-3.563-.682-3.984-.032-.132-.06-.259-.084-.383-.427-2.237-.01-3.174,1.974-3.472Z",
    fill: "#7b2b1a"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M230.245,175.6l-1.017.9-1.937.7a15.374,15.374,0,0,0-6.824-1.226c-3.882.3-4.412,1.416-4.468,1.485l0,0-.4-.087-1.907-.417-.389-.086a12.082,12.082,0,0,1,.76-2.157c1.528-2.3,5.682-3.791,9.456-3.408.128.012.254.026.379.044a9.1,9.1,0,0,1,5.143,2.126Z",
    fill: "#7b2b1a"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M239.694,371.488v7.561H225.163s.546-2.737,7.437-4l1.014-3.561Z",
    fill: "#133a50"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M217.593,371.488v7.561H203.062s.546-2.737,7.437-4l1.013-3.561Z",
    fill: "#133a50"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M237.252,258.934s2.034,24.355,2.1,44.215,1.254,70.07,1.254,70.07h-8.02S224.322,325,221.315,312.228s-10.822-53.054-10.822-53.054Z",
    fill: "#133a50"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M219.812,285.088s-1.5,30.261-1.8,36.219,0,51.883,0,51.883-7.515.2-7.515,0-7.086-48.906-8-63.587-.38-32.086-1.6-34.117,3.29-16.454,3.29-16.454l10.638,2.837Z",
    fill: "#133a50"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M216.541,200.169s-3.334,7.558,1.682,8.393c7.972,1.327,10.4-8.873,10.4-8.873l8.79,4.526s-.161,54.719,3.294,71.423c2.005,9.7-31.375,5.076-36.272-3.533-4.238-7.451,8.005-69.368,8.005-69.368Z",
    fill: "#fff"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M230.689,200.635c-.242.335-12.03,34.844-8.02,67.32.935,7.574,14.744,1.308,18.038,1.308,0,0,1.566-24.239,1.95-33.253s-3.913-11.977-3.529-16.388,5.178-12.274,5.178-12.274Z",
    fill: "#196aa8"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_7",
    "data-name": "Group 7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M210.98,271.394c1.348-22.578,1.9-69.838,1.9-69.838l-7.966-.592s-3.985,39.638-4.043,44.145c-.024,1.791.536,23.559-.674,27.633C202.884,273.145,210.818,274.114,210.98,271.394Z",
    fill: "#196aa8"
  })))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    d: "M297.745,188.343c-6.254,2.145-12.683,4.389-17.649,8.754s-8.166,11.426-6.074,17.7,10.809,9.923,15.848,5.644c1.811-1.537,2.929-4.177,1.957-6.344-1.923-4.285-8.62-2.276-11.76,1.218-3.724,4.143-6.092,9.809-5.17,15.3s5.72,10.431,11.291,10.426,13.509-8.409,8.74-11.289c-6.055-3.657-13.838,5.052-16.816,11.469s-1.118,15.1,4.969,18.71,20.368-.954,16.627-6.958c-3.954-6.346-15.637,2.8-17.19,10.118s4.173,15.328,11.6,16.23,20.281-7.551,15.143-12.983c-7.425-7.849-19.8,12.137-16.229,22.334s18.337,14.254,26.62,7.317c1.551-1.3,2.951-3.157,2.663-5.161-.479-3.337-5.047-4.277-8.245-3.208-8.343,2.787-12.111,14.462-6.972,21.6s17.408,7.269,22.7.241a6.034,6.034,0,0,0,1.457-4.762c-.523-2.335-3.29-3.654-5.642-3.212a9.2,9.2,0,0,0-5.592,4.2c-4.759,7.05-3.153,17.642,3.483,22.963s17.324,4.59,23.172-1.587c1.524-1.61,2.785-3.763,2.381-5.943-.466-2.521-3.156-4.21-5.719-4.149a9.981,9.981,0,0,0-6.69,3.376c-7.469,7.756-4.277,22.767,5.7,26.813s29.771-7.1,22.765-15.272c-4.679-5.461-13.911,6.35-12.73,13.444s9.34,11.928,16.3,10.1,16.114-11.8,10.741-16.581c-3.8-3.382-9.954,3.768-11.128,8.719a11.687,11.687,0,0,0,6.027,12.788c4.916,2.418,10.935.962,15.663-1.8s8.65-6.718,13.2-9.765a41.306,41.306,0,0,1,31.549-5.912",
    fill: "none",
    stroke: "#7a97e0",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_13",
    "data-name": "Group 13"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    d: "M613.307,220.925c-10.129-6.465-100.42,69.652-97.111,129.788,0,0,17.577-23.737,32.9-35.306s16.816-23.679,16.786-35.672,22.883-7.04,25.464-20.343C595.91,235.852,622.423,226.744,613.307,220.925Z",
    fill: "#ccd8f5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_10",
    "data-name": "Group 10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9",
    "data-name": "Group 9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    d: "M619.239,276.952c-14.587,8.836-10.293,20.613-18.894,27.493-6.254,5-16.692,2.385-21.895,9.2-5.864,7.679.8,18.246,1.3,27.5.681,12.782-10.719,22.366-22.3,26.249-13.452,4.508-30.863,3.1-38.227-10.278-8.692-15.788-2.185-39.591,13.064-47.007,3.7-1.8,8.408-2.29,11.434-5.936,5.108-6.155,1.829-15.008,4.2-22.836,2.3-7.629,9.849-13,16.8-15.374s14.028-2.86,20.819-5.618c9.248-3.756,17.347-12.01,25.047-17.577,6.869-4.966,30.984-14.285,34.906,2C649.053,259.6,631.492,269.531,619.239,276.952Z",
    fill: "#bccef9"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    d: "M620.743,253.219S561.12,283.182,513.549,379.864",
    fill: "none",
    stroke: "#7a97e0",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12",
    "data-name": "Group 12"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11",
    "data-name": "Group 11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M618.732,332.564c-7.306,2.923-9.288,15.241-17.156,16.8-5.723,1.137-11.831-3.931-17.422-1.3-6.3,2.963-5.193,11.849-7.77,17.886-3.558,8.34-14.134,10.707-23.044,9.393-10.345-1.525-21.461-8.1-22.152-19-.815-12.861,10.974-25.854,23.425-25.589,3.023.064,6.3,1.289,9.452-.04,5.323-2.242,5.925-8.934,9.952-13.133,3.925-4.093,10.617-5.041,15.977-4.283s10.21,2.759,15.584,3.223c7.318.632,15.285-1.968,22.143-2.991,6.119-.913,31.112-.431,22.546,12.657C644.335,335.256,628.469,328.667,618.732,332.564Z",
    fill: "#ccd8f5"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    d: "M634.5,320.494s-53.254,4.533-115.175,50.411",
    fill: "none",
    stroke: "#7a97e0",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M460.974,377.748s12.118-21.216,14.094-23.4c12.465-13.8,29-13.95,45.835-10.466,4.871,1.009,17.766,7.783,22.445,6.847,3.645-.73,8.019-14.581,19.684-13.852S575.4,351.455,575.4,351.455s7.316-16.1,18.981-14.609,11.665,12.35,2.916,20.4c0,0,18.591-5.577,36.634,3.062s9.425,19.969,9.425,19.969Z",
    fill: "#bccef9"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group_18",
    "data-name": "Group 18"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    d: "M136.693,220.925c10.129-6.465,100.42,69.652,97.111,129.788,0,0-17.578-23.737-32.9-35.306s-16.816-23.679-16.786-35.672-22.883-7.04-25.464-20.343C154.09,235.852,127.577,226.744,136.693,220.925Z",
    fill: "#ccd8f5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_15",
    "data-name": "Group 15"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14",
    "data-name": "Group 14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    d: "M130.761,276.952c14.587,8.836,10.293,20.613,18.894,27.493,6.254,5,16.692,2.385,21.9,9.2,5.864,7.679-.8,18.246-1.3,27.5-.681,12.782,10.719,22.366,22.3,26.249,13.452,4.508,30.863,3.1,38.227-10.278,8.692-15.788,2.185-39.591-13.064-47.007-3.7-1.8-8.408-2.29-11.434-5.936-5.108-6.155-1.829-15.008-4.2-22.836-2.3-7.629-9.849-13-16.8-15.374s-14.028-2.86-20.819-5.618c-9.248-3.756-17.347-12.01-25.047-17.577-6.869-4.966-30.984-14.285-34.906,2C100.947,259.6,118.508,269.531,130.761,276.952Z",
    fill: "#bccef9"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    d: "M129.257,253.219s59.623,29.963,107.194,126.645",
    fill: "none",
    stroke: "#7a97e0",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    d: "M93.251,298.379s76.664-.858,140.367,72.215",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_17",
    "data-name": "Group 17"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16",
    "data-name": "Group 16"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    d: "M131.268,332.564c7.306,2.923,9.288,15.241,17.156,16.8,5.723,1.137,11.831-3.931,17.422-1.3,6.3,2.963,5.193,11.849,7.769,17.886,3.559,8.34,14.135,10.707,23.045,9.393,10.345-1.525,21.461-8.1,22.152-19,.815-12.861-10.974-25.854-23.425-25.589-3.023.064-6.3,1.289-9.452-.04-5.324-2.242-5.925-8.934-9.952-13.133-3.925-4.093-10.617-5.041-15.977-4.283s-10.21,2.759-15.584,3.223c-7.318.632-15.285-1.968-22.143-2.991-6.119-.913-31.112-.431-22.546,12.657C105.665,335.256,121.531,328.667,131.268,332.564Z",
    fill: "#ccd8f5"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    d: "M115.5,320.494s53.254,4.533,115.175,50.411",
    fill: "none",
    stroke: "#7a97e0",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    d: "M289.026,377.748s-12.119-21.216-14.1-23.4c-12.464-13.8-29-13.95-45.834-10.466-4.871,1.009-17.766,7.783-22.445,6.847-3.645-.73-8.019-14.581-19.684-13.852S174.6,351.455,174.6,351.455s-7.317-16.1-18.981-14.609-11.665,12.35-2.916,20.4c0,0-18.591-5.577-36.634,3.062s-9.425,19.969-9.425,19.969Z",
    fill: "#bccef9"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_25",
    "data-name": "Group 25"
  }, _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Group_19",
    "data-name": "Group 19"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    d: "M419.623,379.6H400.764a4,4,0,0,1-3.987-3.67l-1.235-14.889h29.3l-1.235,14.889A4,4,0,0,1,419.623,379.6Z",
    fill: "#21295b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    d: "M530.975,379.6H512.117a4,4,0,0,1-3.987-3.67l-1.236-14.889h29.3l-1.235,14.889A4,4,0,0,1,530.975,379.6Z",
    fill: "#21295b"
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    d: "M534.244,341.5H397.5l9.669-70.5a11.108,11.108,0,0,1,11.005-9.6h95.4a11.107,11.107,0,0,1,11,9.6Z",
    fill: "#7a97e0"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    d: "M515.789,327.827H415.951L423.043,257a10.3,10.3,0,0,1,10.248-9.273h65.158A10.3,10.3,0,0,1,508.7,257Z",
    fill: "#7a97e0"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    "data-name": "Path 41",
    d: "M399.691,325.5l-2.2,16H534.244l-2.2-16Z",
    fill: "#407bff",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    "data-name": "Path 42",
    d: "M549.045,368.851H382.695l3.079-36.141H545.965Z",
    fill: "#6489e8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_24",
    "data-name": "Group 24"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1",
    "data-name": "Ellipse 1",
    cx: 30.435,
    cy: 30.435,
    r: 30.435,
    transform: "translate(423.759 282.902) rotate(-33.065)",
    fill: "#cfcfcf",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2",
    "data-name": "Ellipse 2",
    cx: 26.316,
    cy: 26.316,
    r: 26.316,
    transform: "translate(438.946 266.109) rotate(-1.34)",
    fill: "#fff"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Group_23",
    "data-name": "Group 23"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20",
    "data-name": "Group 20"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    "data-name": "Path 43",
    d: "M473.225,313.445a3.437,3.437,0,0,1-2.421-1,2.773,2.773,0,0,1-.42-.527,3.371,3.371,0,0,1-.322-.586,4.786,4.786,0,0,1-.2-.634,3.949,3.949,0,0,1-.068-.674,3.427,3.427,0,0,1,4.089-3.348,3.669,3.669,0,0,1,.635.2,3.821,3.821,0,0,1,.6.312,3.568,3.568,0,0,1,.516.43,3.435,3.435,0,0,1,1.006,2.41,3.951,3.951,0,0,1-.069.674,4.641,4.641,0,0,1-.194.634,4.258,4.258,0,0,1-.313.586,3.23,3.23,0,0,1-.43.527,3.568,3.568,0,0,1-.516.42,2.684,2.684,0,0,1-.6.312,3.025,3.025,0,0,1-.635.2A3.178,3.178,0,0,1,473.225,313.445Z",
    fill: "#b3b3b3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_21",
    "data-name": "Group 21"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    "data-name": "Path 44",
    d: "M462.634,314.645h0a3.416,3.416,0,0,1-2.9-3.865h0a3.417,3.417,0,0,1,3.865-2.9h0a3.428,3.428,0,0,1,2.9,3.866h0a3.422,3.422,0,0,1-3.388,2.937h0A2.647,2.647,0,0,1,462.634,314.645Zm-10.981-4.665h0a3.427,3.427,0,0,1-.586-4.8h0a3.415,3.415,0,0,1,4.793-.585h0a3.415,3.415,0,0,1,.586,4.792h0a3.4,3.4,0,0,1-2.7,1.318h0A3.4,3.4,0,0,1,451.653,309.98Zm-7.174-9.547a3.4,3.4,0,0,1,1.884-4.441h0a3.419,3.419,0,0,1,4.451,1.884h0a3.432,3.432,0,0,1-1.894,4.451h0a3.457,3.457,0,0,1-1.279.244h0A3.391,3.391,0,0,1,444.479,300.433Zm1.445-7.984a3.422,3.422,0,0,1-2.909-3.865h0a3.419,3.419,0,0,1,3.865-2.9h0a3.419,3.419,0,0,1,2.909,3.855h0a3.422,3.422,0,0,1-3.387,2.938h0A3.835,3.835,0,0,1,445.924,292.449Zm2.352-10.054a3.416,3.416,0,0,1-.6-4.792h0a3.409,3.409,0,0,1,4.793-.6h0a3.408,3.408,0,0,1,.6,4.793h0a3.394,3.394,0,0,1-2.694,1.318h0A3.4,3.4,0,0,1,448.276,282.395ZM475.86,279a3.409,3.409,0,0,1-.6-4.792h0a3.417,3.417,0,0,1,4.793-.6h0a3.428,3.428,0,0,1,.6,4.8h0a3.428,3.428,0,0,1-2.7,1.318h0A3.437,3.437,0,0,1,475.86,279Zm-20.527-4.138a3.4,3.4,0,0,1,1.883-4.441h0a3.418,3.418,0,0,1,4.452,1.884h0a3.423,3.423,0,0,1-1.894,4.451h0A3.421,3.421,0,0,1,458.5,277h0A3.4,3.4,0,0,1,455.333,274.86Zm12.777.859a3.416,3.416,0,0,1-2.9-3.865h0a3.407,3.407,0,0,1,3.856-2.9h0a3.407,3.407,0,0,1,2.908,3.856h0a3.419,3.419,0,0,1-3.377,2.938h0A3.99,3.99,0,0,1,468.11,275.719Z",
    fill: "#b3b3b3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_22",
    "data-name": "Group 22"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    d: "M484.1,287.871a3.726,3.726,0,0,1-.663-.068,3.517,3.517,0,0,1-.645-.2,4.1,4.1,0,0,1-.585-.313,3.723,3.723,0,0,1-.527-.429,3.429,3.429,0,0,1-1-2.411,3.212,3.212,0,0,1,.068-.674,2.975,2.975,0,0,1,.2-.634,3.372,3.372,0,0,1,.312-.6,3.521,3.521,0,0,1,.42-.518,3.958,3.958,0,0,1,1.112-.742,3.5,3.5,0,0,1,.645-.185,3.436,3.436,0,0,1,3.074.927,3.028,3.028,0,0,1,.429.518,3.445,3.445,0,0,1,.313.6,3.034,3.034,0,0,1,.2.634,3.21,3.21,0,0,1,.067.674,3.431,3.431,0,0,1-3.416,3.416Z",
    fill: "#b3b3b3"
  })))))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Group_26",
    "data-name": "Group 26"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    "data-name": "Path 46",
    d: "M426.628,180.948a14.6,14.6,0,0,1,2.931-15.266s24.748,16.035,52.409,11.511c0,0,3.033,8.342-5.47,16.068C476.5,193.261,446.889,198.875,426.628,180.948Z",
    fill: "#6489e8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    "data-name": "Path 47",
    d: "M468.992,145.451c-17.808-15.017-51.543-17.128-94.244-10.253-36.717,5.911-74.113,19.78-86.595,39.369-5.685,8.922-1.824,33.7-1.824,33.7,33.824,2.113,46.213-26.966,46.213-26.966s-2.262-8.251,5.316-11.9c26.516-12.76,67.627-17.119,82.92-13.351a11.329,11.329,0,0,1,8.781,9.628S450.45,189.4,481.9,176.78C481.9,176.78,477.079,152.271,468.992,145.451Z",
    fill: "#7a97e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48",
    "data-name": "Path 48",
    d: "M339.453,194.593a14.6,14.6,0,0,0-7.575-13.574s-18.465,22.992-46.147,27.379c0,0-.262,8.872,10.237,13.538C295.968,221.936,325.842,217.974,339.453,194.593Z",
    fill: "#6489e8"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Group_31",
    "data-name": "Group 31"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_29",
    "data-name": "Group 29"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_53",
    "data-name": "Path 53",
    d: "M395.473,207.44s4.619-13.33,4.943-14.8c1.914-8.662,2.434-27.441,2.314-31.435s-.492-7.5-.57-8.037-2.557-3.205-2.566-3.167a5.415,5.415,0,0,1-.77.082l-.029.5-1.071-.922-.892-.05-.1.418-1.273-.611-1.227-.022s.792,2.535,1.243,4.076-.02,1.669-.02,1.669a3.359,3.359,0,0,1-1.375.255,9.573,9.573,0,0,0-1.743-.075s3.73,4.852,3.9,5.3a8.782,8.782,0,0,1,1.5,7.019,179.1,179.1,0,0,1-5.313,19.408c.116-.272-5.019,14.387-5.019,14.387Z",
    fill: "#fec4ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54",
    "data-name": "Path 54",
    d: "M392.991,225.084c1.43-11.219,7.171-24.32,7.171-24.32s-8.773-1.737-11.04-4.857c0,0-3.023,7.384-4.763,11.056-1.924,4.065-4.623,8.49-1.231,10.9C386.4,220.2,392.493,228.992,392.991,225.084Z",
    fill: "#00b9f2"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_55",
    "data-name": "Path 55",
    d: "M359.364,372.337v7.212h13.861s-.521-2.61-7.094-3.815l-.967-3.4Z",
    fill: "#133a50"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56",
    "data-name": "Path 56",
    d: "M380.446,372.337v7.212h13.862s-.521-2.61-7.1-3.815l-.966-3.4Z",
    fill: "#133a50"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57",
    "data-name": "Path 57",
    d: "M361.693,264.971s-1.94,20.154-2.008,39.1-1.2,69.918-1.2,69.918h7.651s7.888-49.078,10.756-61.257S387.219,265.2,387.219,265.2Z",
    fill: "#133a50"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58",
    "data-name": "Path 58",
    d: "M373.455,198.129s-.495,3.856-.9,5.819a15.708,15.708,0,0,1-1.044,3.6c-.663,1.329-4.733,5.375-4.733,5.375s12.685,6.7,16.414,6.7,2.422-7.48,2.422-7.48-4.067-3.214-4.672-4.838A36.493,36.493,0,0,1,380,200.97Z",
    fill: "#fec4ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59",
    "data-name": "Path 59",
    d: "M378.33,286.842s1.433,31.943,1.72,37.627,0,49.491,0,49.491,7.169.194,7.169,0,6.759-49.729,7.635-63.733.363-30.608,1.526-32.544-3.139-12.619-3.139-12.619l-10.147-.371Z",
    fill: "#133a50"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60",
    "data-name": "Path 60",
    d: "M369.361,209.148s-10.709-4.3-12.481-.77c-1.338,2.666-.187,19.8.408,24.591.518,4.165,3.4,39.207,3.4,39.207s4,6.2,23.267,3.733c7.429-.953,11.081-4.573,11.081-4.573s-2.083-41.813-2.656-46.008a90.511,90.511,0,0,0-2.556-10.742l-5.735-3.776s1.828,4.037-3.346,5.187C370.315,218.314,369.361,209.148,369.361,209.148Z",
    fill: "#00b9f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61",
    "data-name": "Path 61",
    d: "M383.593,183.55c1.214.487,3.337,1.582,3.574,2.6a40.252,40.252,0,0,1,1.21,5.732c.112,1.78.367,5.146.365,7.244s-1.27,6.342-1.748,6.791a10.433,10.433,0,0,1-5.193.838c-1.192-.34-8.182-3.956-8.62-8.383,0,0-1.24.652-3.518-3.042-.6-.963,1.456-8.12,1.731-9.4.669-3.1,8.314-.658,10.029-1.147A3.722,3.722,0,0,0,383.593,183.55Z",
    fill: "#fec4ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62",
    "data-name": "Path 62",
    d: "M387.167,186.145s-5.356,3.353-7.445,3.526-5.158,3.044-5.1,3.935a1.935,1.935,0,0,1-.881,1.5s-1.3-2.072-2.366-1.856c-2.111.427-.871,3.03.275,3.6a17.7,17.7,0,0,0,2.259.925,10.924,10.924,0,0,1,.1,2.232,10.243,10.243,0,0,1-.893,2.615s-2.472-5.205-4.689-7.147c-5.269-4.618-1.455-13.2,3.737-14.811,2.1-.651,7.852-1.083,10.655.173A7.634,7.634,0,0,1,387.167,186.145Z",
    fill: "#133a50"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63",
    "data-name": "Path 63",
    d: "M375.947,193.479c.078.21.626.248.728.293.219.1.124.129,1.088,1.6.712,1.088,1.9,1.44,4.132.7,1.7-.569,1.464-2.031,1.584-2.728s.268-.814.539-.861.419.017.769.631.513,2.2,2.29,1.931c1.225-.184,1.548-.522,1.714-1.491a10.09,10.09,0,0,0,.14-2.347c-.048-.642-.062-1.033-.388-1.067a5.964,5.964,0,0,0-1.459.16,5.891,5.891,0,0,0-2.4.624c-.575.416-.512.671-.814.728s-.362-.206-1.044-.4a20.666,20.666,0,0,0-4.568.486c-1.06.186-2.516.584-2.487.985A3,3,0,0,0,375.947,193.479Zm9.161-1.579c.054-.52.094-.463,1.4-.762s1.448-.242,1.712-.033a2.793,2.793,0,0,1,.325,2.115,1.449,1.449,0,0,1-1.265,1.518c-1.154.2-1.423-.369-1.75-1.169A4.977,4.977,0,0,1,385.108,191.9Zm-7.637.853c.177-.286,1.952-.528,3.286-.692s1.779-.22,2.007.25a4.943,4.943,0,0,1,.167,1.715c-.034.863-.2,1.619-2.283,1.994a2.235,2.235,0,0,1-2.784-1.24A2.432,2.432,0,0,1,377.471,192.753Zm-4.452,1.325,2.928-.6.989-1.445s-1.124.16-2.983.573a5.7,5.7,0,0,0-1.763.831A2.876,2.876,0,0,1,373.019,194.078Z",
    fill: "#21295b"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_30",
    "data-name": "Group 30"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_64",
    "data-name": "Path 64",
    d: "M349.929,208.665s-2.534-16.051-2.558-17.553c-.145-8.87,4.351-20.787,5.267-24.676s1.525-3.274,1.709-3.785,6.626-1.5,6.626-1.5a17.178,17.178,0,0,1,2.136-.763c.4-.04,2.1-.548,2.1-.548l-.989,1.777s-4.016,3.055-4.274,3.461a8.78,8.78,0,0,0-2.872,6.579c-.165,7.936-.14,16.534-.14,16.534-.059-.29,3.8,16.436,3.8,16.436Z",
    fill: "#fec4ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65",
    "data-name": "Path 65",
    d: "M357.288,232.969c-2.726-7.736-8.961-28.511-8.961-28.511s9.271-2.334,11.886-5.168c0,0,3.128,9.289,4.428,13.14,1.438,4.261,3.6,8.971-.047,10.973C361.07,225.336,358.6,236.684,357.288,232.969Z",
    fill: "#00b9f2"
  })))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Group_35",
    "data-name": "Group 35"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_32",
    "data-name": "Group 32"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_66",
    "data-name": "Path 66",
    d: "M536.58,245.933c2.407,2.24,4.109,1.49,7.723,13.862,2.309,7.9,10.731,47.771,10.731,47.771L550,309.749c-6.8-19.056-6.794-19.037-14.743-34.5a68.78,68.78,0,0,1-5.466-14.891l-14.694-.882c-9.187-3.775-6.038-17.184-6.038-17.184S534.172,243.693,536.58,245.933Z",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67",
    "data-name": "Path 67",
    d: "M480.917,234.081l13.258-8.491L507,235.553l15.975,5.16-.086.049c6.425,2.229,13.762,5.481,16.015,7.576,2.407,2.24,7.151,5.42,3.325,17.728-2.444,7.864-13.1,47.7-13.1,47.7l-5.4-.961s1.918-23.083,3.84-40.351c.931-8.371,1.247-10.706,1.247-10.706s-35.669,3.889-47.161-2.18C473.613,255.32,480.917,240.517,480.917,234.081Z",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_68",
    "data-name": "Path 68",
    d: "M529.507,310.881s-.157,1.45-2.48,2.1a3.953,3.953,0,0,1-3.9-1.265l-.515,4.737,7.419,5.23h6.163l-3.334-3.7Z",
    fill: "#133a50"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69",
    "data-name": "Path 69",
    d: "M554.238,304.318a2.546,2.546,0,0,1-.92,3.361,3.952,3.952,0,0,1-4.1-.016l.952,4.668,17.52-5.48Z",
    fill: "#133a50"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_34",
    "data-name": "Group 34"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_70",
    "data-name": "Path 70",
    d: "M534.069,186.3a37.4,37.4,0,0,1-2.919-3.474l-.673-3.05s-1.18-1.578-2.092-2.531-1.722-5.038-1.722-5.038l1.186-.715a14.818,14.818,0,0,0,.936,2.23,2.119,2.119,0,0,0,1.15.47,22.237,22.237,0,0,0,.036-2.842,24.879,24.879,0,0,0-1.084-4.8l.989-.482a21.763,21.763,0,0,1,.948,2.2c.209.7.574,2.129.574,2.129a23.991,23.991,0,0,0-.3-3.249c-.23-.938-.4-2.157-.4-2.157l1.036-.266a19.856,19.856,0,0,1,.688,2.621c.166,1.074.535,2.891.535,2.891a31.433,31.433,0,0,0,.04-3.306,10.773,10.773,0,0,1-.108-1.163l1.1.028a8.38,8.38,0,0,1,.389,2.491,11.6,11.6,0,0,0,.111,1.98,12.509,12.509,0,0,0,.307-2.7,2.3,2.3,0,0,1-.041-.916l.848.144s.481,3.365.635,5.4-.093,4.61-.112,6.047-.055,2.56-.055,2.56Z",
    fill: "#fec4ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71",
    "data-name": "Path 71",
    d: "M511.6,190.239a133.466,133.466,0,0,0,13.674,9.768s2.544-6.38,3.756-10.9c1.448-5.4,1.873-7.884,1.873-7.884l5.158-.422s-1.634,13.8-3.664,23.166c-1.973,9.1-4.453,7.475-6.634,7.029s-22.71-11.477-22.71-11.477l2.2-11.722S506.715,186.224,511.6,190.239Z",
    fill: "#fec4ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72",
    "data-name": "Path 72",
    d: "M489.911,157.091c1.1-.626,6.4-1.062,9.719.983,6.35,3.91,3.3,14.623,2.9,17.09s1.88,6.913,1.843,9.86-.74,4.014-2.94,6.867a5.463,5.463,0,0,0-.82,2.278,21.027,21.027,0,0,1-2.955-8.707c-.52-5.069-1.6-3.887-4.132-9.454s-2.647-13.95-2.647-13.95Z",
    fill: "#471a16"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73",
    "data-name": "Path 73",
    d: "M495.192,160.723l-5.281-3.632a7.722,7.722,0,0,0-7.131,3.41c-2.619,4.013-3.532,9.824-4.121,14.19s-2.127,12.573-2.022,15.829,4.061,3.7,4.061,3.7l13.267-5.74a39.378,39.378,0,0,1-.123-14.411A71.507,71.507,0,0,0,495.192,160.723Z",
    fill: "#471a16"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74",
    "data-name": "Path 74",
    d: "M499.61,161.833c.276,1.651,1.555,6.5,1.683,9.612s-.243,8.236-2.3,9.651-5.93.285-8.762-.887-3.516-3.158-4.069-4.984-.358-6.675.289-10.15a6.188,6.188,0,0,1,5.409-5.354C494.414,159.243,499.61,161.833,499.61,161.833Z",
    fill: "#fec4ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75",
    "data-name": "Path 75",
    d: "M488.039,173.409s.724,7.732-.9,11.371c-1.122,2.511-5.668,3.576-5.668,3.576a25.635,25.635,0,0,0,4.391,13.669c4.562,6.714,18.828,9.2,18.828,9.2a62.25,62.25,0,0,0,4.259-11.886,13.868,13.868,0,0,0-2.513-11.135s-3.857-1.262-5.708-1.959c-4.5-1.693-3.969-8.838-3.969-8.838Z",
    fill: "#fec4ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_76",
    "data-name": "Path 76",
    d: "M496.707,191.33s-9.223-2.343-11.994-4.142l-9.146,5.436s-5.373,5.128,3.8,18.6c0,0,3.48,12.274-2.169,33.9,0,0,1.527,5.57,10.094,2.6,7.374-2.552,7.54-4.547,14-6.186,9.538-2.419,12.047-3.907,12.047-3.907-5.01-7.528-4.119-19.286-4.119-19.286s5.68-5.437,3.245-10.993c-3.514-8.021-4.692-19.371-4.692-19.371l-4.9-1.241a36.893,36.893,0,0,1-3.911,4.165A2.1,2.1,0,0,1,496.707,191.33Z",
    fill: "#196aa8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77",
    "data-name": "Path 77",
    d: "M500.726,186.243s-1.123,4.179-4.019,5.087c0,0,1.133,5.725,3.844,4.73,3.806-1.4,2.323-9.314,2.323-9.314Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78",
    "data-name": "Path 78",
    d: "M483.61,186.484s1.807,8.744,6.638,9.452,6.459-4.606,6.459-4.606-10.241-3-11.242-6.137Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79",
    "data-name": "Path 79",
    d: "M492.123,159.637c-.891.058-1.548,4.272-1.638,6.623s-3.61,4.206-2.057,9.379,1.344,10.167,3.426,15.835-.511,7.745-1.636,9.7a75.4,75.4,0,0,1-5.966-7.33,5.883,5.883,0,0,0-6.373-2.856s6.8-13.217,6.575-16.781-.859-9.006,1.978-12.259S492.123,159.637,492.123,159.637Z",
    fill: "#471a16"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80",
    "data-name": "Path 80",
    d: "M488.542,170.192s-1.892-2.072-3.141-1.756-1.328,2.189-.377,3.724,4.472,2.4,4.472,2.4Z",
    fill: "#fec4ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_81",
    "data-name": "Path 81",
    d: "M492.847,166.158a25.066,25.066,0,0,0,5.37-.389c3.431-.377,4.877.5,4.877.5l-1.3-5.7s-4.005-2.226-6.842-2.206c-3.611.024-6.771,1.406-4.982,2.573C491.867,162.171,492.847,166.158,492.847,166.158Z",
    fill: "#471a16"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_33",
    "data-name": "Group 33"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_82",
    "data-name": "Path 82",
    d: "M483.331,199.016c-.613,7.157-2.718,27.551-2.718,27.551,6.512,5.7,15.731,15.172,15.731,15.172s-2.624,5.174-3.746,4.3c-8.973-7.014-19.229-11.166-19.962-16.049-1.2-8.02-1.617-28.2,1.336-34.764C476.249,190.164,483.98,191.424,483.331,199.016Z",
    fill: "#fec4ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_83",
    "data-name": "Path 83",
    d: "M500.3,242.371c2.727,1.024,4.443,2.028,4.28,3.045-.112.7-2.439-.58-3.832-.535a7.732,7.732,0,0,0,3.314,3.252c1.8.887,2.809,2.118,1.845,3.16s-2.742,2.5-3.9,1.967-5.277-3.409-6.827-4.205-2.17-2.745-2.968-3.28,1.461-4.635,1.461-4.635c.429.119,2.677.6,2.677.6a14.3,14.3,0,0,0,2.229.186A5.44,5.44,0,0,1,500.3,242.371Z",
    fill: "#fec4ad"
  }))))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Group_63",
    "data-name": "Group 63",
    transform: "matrix(0.996, 0.087, -0.087, 0.996, -20.462, 80.564)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_60",
    "data-name": "Group 60",
    transform: "translate(226.274 198.088)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_160",
    "data-name": "Path 160",
    d: "M344.965,220.724l4.749,55.338c.386,4.5-2.37,8.45-6.124,8.772l-105,9.012c-3.754.322-7.142-3.1-7.529-7.6l-4.749-55.338a9.428,9.428,0,0,1,.238-3.1c.755-3.089,3.029-5.428,5.885-5.673l105-9.011c2.85-.245,5.5,1.673,6.765,4.581A9.462,9.462,0,0,1,344.965,220.724Z",
    transform: "translate(-226.274 -213.102)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161",
    "data-name": "Path 161",
    d: "M344.965,220.724l4.749,55.338c.386,4.5-2.37,8.45-6.124,8.772l-105,9.012c-3.754.322-7.142-3.1-7.529-7.6l-4.749-55.338a9.428,9.428,0,0,1,.238-3.1c.755-3.089,3.029-5.428,5.885-5.673l105-9.011c2.85-.245,5.5,1.673,6.765,4.581A9.462,9.462,0,0,1,344.965,220.724Z",
    transform: "translate(-226.274 -213.102)",
    opacity: 0.1
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_162",
    "data-name": "Path 162",
    d: "M350.426,206.238l6.864,56.752c.559,4.618-2.134,8.776-5.985,9.243L243.619,285.257c-3.85.466-7.457-2.931-8.016-7.549l-6.865-56.752a9.721,9.721,0,0,1,.134-3.2c.666-3.2,2.922-5.692,5.851-6.046L342.41,198.688c2.922-.354,5.713,1.524,7.122,4.47A9.751,9.751,0,0,1,350.426,206.238Z",
    transform: "translate(-0.76 -10.423)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_163",
    "data-name": "Path 163",
    d: "M349.629,203.158l-48.844,32.89a18.042,18.042,0,0,1-16.544,2L228.97,217.76c.666-3.2,2.922-5.692,5.851-6.046l107.686-13.025C345.429,198.335,348.22,200.212,349.629,203.158Z",
    transform: "translate(-0.856 -10.423)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_62",
    "data-name": "Group 62",
    transform: "translate(244.541 165.82)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_164",
    "data-name": "Path 164",
    d: "M339.052,205l-14.035,9.447-4.589,3.094-12,8.079a17.965,17.965,0,0,1-16.112,2.144c-.142-.037-.284-.089-.426-.142l-6.734-2.473-15.148-5.56-7.085-2.6-8.026-2.945-.575-14.191-1.278-31.53,61.648-2.5,23.5,17.808.246,6.053Z",
    transform: "translate(-253.041 -165.82)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_165",
    "data-name": "Path 165",
    d: "M339.052,205l-14.035,9.447-4.589,3.094-12,8.079a17.965,17.965,0,0,1-16.112,2.144c-.142-.037-.284-.089-.426-.142l-6.734-2.473-15.148-5.56-7.085-2.6-8.026-2.945-.575-14.191-1.278-31.53,61.648-2.5,23.5,17.808.246,6.053Z",
    transform: "translate(-253.041 -165.82)",
    fill: "#fafafa",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_61",
    "data-name": "Group 61",
    transform: "translate(7.563 21.175)",
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_166",
    "data-name": "Path 166",
    d: "M333.879,199.752l-68.244,2.771a1.457,1.457,0,0,1-1.511-1.393h0a1.458,1.458,0,0,1,1.393-1.511l68.244-2.771a1.457,1.457,0,0,1,1.511,1.393h0A1.458,1.458,0,0,1,333.879,199.752Z",
    transform: "translate(-264.122 -196.847)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_167",
    "data-name": "Path 167",
    d: "M334.418,213.036l-68.244,2.771a1.458,1.458,0,0,1-1.511-1.393h0a1.458,1.458,0,0,1,1.393-1.511l68.245-2.771a1.457,1.457,0,0,1,1.511,1.393h0A1.458,1.458,0,0,1,334.418,213.036Z",
    transform: "translate(-264.293 -201.065)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_168",
    "data-name": "Path 168",
    d: "M334.958,226.32l-68.245,2.771a1.457,1.457,0,0,1-1.51-1.394h0a1.456,1.456,0,0,1,1.393-1.51l68.244-2.771a1.458,1.458,0,0,1,1.511,1.393h0A1.458,1.458,0,0,1,334.958,226.32Z",
    transform: "translate(-264.465 -205.284)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_169",
    "data-name": "Path 169",
    d: "M329.614,237.075l-4.589,3.094L274.6,242.217l-7.085-2.6a.739.739,0,0,1,.179-.023Z",
    transform: "translate(-265.2 -209.621)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_170",
    "data-name": "Path 170",
    d: "M321.282,252.974v.053a1.462,1.462,0,0,1-1.39,1.465L307.255,255c-.142-.037-.284-.089-.426-.142l-6.734-2.473,19.677-.8A1.457,1.457,0,0,1,321.282,252.974Z",
    transform: "translate(-275.545 -214.228)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_171",
    "data-name": "Path 171",
    d: "M366.87,183.629l-16.327-.7-7.169-17.1Z",
    transform: "translate(-281.725 -165.821)",
    fill: "#263238",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_172",
    "data-name": "Path 172",
    d: "M366.87,183.629l-15.841-2.715-7.656-15.091Z",
    transform: "translate(-281.725 -165.821)",
    fill: "#407bff"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactUs);
export default __webpack_public_path__ + "static/media/ContactUS.b1fefdd921f9c5fbf8acf6b6d53ff4a5.svg";
export { ForwardRef as ReactComponent };